import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, createStyleSheet} from 'material-ui/styles'
import Card, {CardHeader, CardContent,} from 'material-ui/Card';

const styleSheet = createStyleSheet('Verbline', theme => ({
    pronoun: {
        marginRight: theme.spacing.unit,
    },
    pronounAfirmativo: {
        marginLeft: theme.spacing.unit,
        fontWeight: 'italic'
    },
    negative: {
        marginRight: theme.spacing.unit,
    },
    pronounNegative: {
        marginLeft: theme.spacing.unit,
        fontWeight: 'italic'
    },

    auxiliar: {
        marginRight: theme.spacing.unit,
    },
    stem: {
        marginRight: 0,
    },
    termination: {
        fontWeight: 'bold',
    },
    content: {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
    }
}));


class Conjugate extends Component {

    build(verb) {
        const classes = this.props.classes
        let comp = []
        let key = 0
        comp.push(<CardHeader title="Conjugação do verbo" key={key++}/>)
        for (let mode in verb) {
            let m = mode
            for (let tense in verb[mode]) {

                comp.push(<CardHeader title={m} subheader={tense}  key={key++} />)
                m = ''
                let conj = verb[mode][tense];
                let len = conj.length

                for (let i = 0; i < len; i++) {
                    let line = conj[i]
                    let lineLen = line.length

                    if (lineLen === 2) {

                        comp.push(
                            <CardContent className={classes.content} key={key++}>
                                <span className={classes.stem}>{line[0]}</span>
                                <span className={classes.termination}>{line[1]}</span>
                            </CardContent>
                        )

                    }

                    if (lineLen === 3) {
                        if (tense === 'Afirmativo') {

                            comp.push(
                                <CardContent className={classes.content} key={key++}>
                                    <span className={classes.stem}>{line[0]}</span>
                                    <span className={classes.termination}>{line[1]}</span>
                                    <span className={classes.pronounAfirmativo}>({line[2]})</span>
                                </CardContent>
                            )

                        } else {

                            comp.push(
                                <CardContent className={classes.content} key={key++}>
                                    <span className={classes.pronoun}>{line[0]}</span>
                                    <span className={classes.stem}>{line[1]}</span>
                                    <span className={classes.termination}>{line[2]}</span>
                                </CardContent>
                            )
                        }
                    }

                    if (lineLen === 4) {
                        if (tense === 'Negativo' || tense === 'Infinitivo pessoal') {

                            comp.push(
                                <CardContent className={classes.content} key={key++}>
                                    <span className={classes.negative}>{line[0]}</span>
                                    <span className={classes.stem}>{line[1]}</span>
                                    <span className={classes.termination}>{line[2]}</span>
                                    <span className={classes.pronounNegative}>({line[3]})</span>
                                </CardContent>
                            )

                        } else {

                            comp.push(
                                <CardContent className={classes.content} key={key++}>
                                    <span className={classes.pronoun}>{line[0]}</span>
                                    <span className={classes.auxiliar}>{line[1]}</span>
                                    <span className={classes.stem}>{line[2]}</span>
                                    <span className={classes.termination}>{line[3]}</span>
                                </CardContent>
                            )
                        }
                    }

                }
            }
        }
        return comp
    }


    render() {
        const verb = this.props.verb;
        if (Object.keys(verb).length === 0) {
            return null
        }
        return (
            <Card>
                {this.build(verb)}
            </Card>

        )
    }
}


Conjugate
    .propTypes = {
    verb: PropTypes.object.isRequired,
};


export default withStyles(styleSheet)(Conjugate)



// WEBPACK FOOTER //
// ./src/conjudate.jsx